<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content">
      <div class="container">
        <div style="height:90vh; justify-content:center; align-items: center;" class="row">
          <div class="col-lg-8 text-center ">
            <h2 class="title text-danger">404 Not Found</h2>
            <h2 class="title">Oops! It seems that this page does not exist.</h2>
            <router-link :to="{path:'/'}" class="navbar-brand">back to Prism</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
